import "firebase/compat/storage"
import firebase from "firebase/compat/app";
import "firebase/compat/auth"
import "firebase/compat/database"
// import "firebase/compat/analytics"

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAyWKZtBX49YrlzoAedfJYPjHPu-SNFEtU",
    authDomain: "geolightminingservices.firebaseapp.com",
    projectId: "geolightminingservices",
    storageBucket: "geolightminingservices.firebasestorage.app",
    messagingSenderId: "511994480468",
    appId: "1:511994480468:web:aebe6c461b204019952ac1",
    measurementId: "G-WC3WSDVCVG"
})
const auth = firebaseApp.auth()
const db = firebaseApp.database()
// const analytics = firebaseApp.analytics()
const storage = firebaseApp.storage()

// analytics.setAnalyticsCollectionEnabled(true)

export { auth, db, storage }